/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useNoteSettingsContext } from '../note-settings/note-settings-context'
import { TimeFromNow } from '../time-from-now'
import { NoteInfoEntry } from './note-info-entry'
import { DateTime } from 'luxon'
import React, { useMemo } from 'react'
import { Plus as IconPlus } from 'react-bootstrap-icons'
import { useTranslation } from 'react-i18next'

/**
 * Renders an info line about the creation time of the note.
 */
export const NoteInfoLineCreatedAt: React.FC = () => {
  useTranslation()
  const noteCreateTime = useNoteSettingsContext().info.createdAt
  const noteCreateDateTime = useMemo(() => DateTime.fromISO(noteCreateTime), [noteCreateTime])

  return (
    <NoteInfoEntry titleI18nKey={'editor.noteInfo.created'} icon={IconPlus}>
      <TimeFromNow time={noteCreateDateTime} />
    </NoteInfoEntry>
  )
}
